export const canEditPrecioPublicacion = (publicacion, publicacionInicial) => {
    const verifyPrecio = ["precioLista", "precioPromocional", "stock", "alicuotaIva", "alicuotaImpuestoInterno"];
    const canEditPrecio = verifyPrecio.some(item => publicacion[item] !== publicacionInicial[item]);

    // Si el stock cambió a 0, la publicación se pausa automáticamente
    if (publicacion.stock === 0 && publicacion.stock !== publicacionInicial.stock) {
        publicacion.estado = "pausado";
    }
    // Si el stock cambió y ahora es mayor a 0, la publicación se activa automáticamente
    else if (publicacion.stock > 0 && publicacionInicial.stock === 0) {
        publicacion.estado = "activo";
    }

    return canEditPrecio;
}